import { TransformPlainObject } from './transform.plainObject';
import { ExpressionColumnPlainObject } from './expressionColumn.plainObject';

export class StringifyPlainObject extends TransformPlainObject {
    public columns: ExpressionColumnPlainObject[] = [];
}
